<script lang="ts" setup>
import { onMounted, onUnmounted, Ref, ref, watch } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmDrawer,
  TirPmDrawerPositionEnum,
  TirPmStatusBudge,
  TirPmTooltipElementPlacementEnum,
  TirPmTooltipElement,
} from 'tir-components';
import { CreateNamespaceForm, CreateNamespaceResultModel } from '../create-namespace-form';
import { CrossLinedIcon } from 'tir-style-system/icons/outline';

const emit = defineEmits<{
  /**Событие создания рабочей области */
  (e: 'onCreate', value: CreateNamespaceResultModel): void;
}>();

defineProps({
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
});

/**Состояние видимости TooltipElement */
const tooltipElementVisibleState: Ref<boolean> = ref();

/**Видимость tir-pm-drawer */
const visible = ref(false);

watch(
  () => visible.value,
  () => {
    if (!visible.value) tooltipElementVisibleState.value = false;
  },
);

const open = () => (visible.value = true);

/**изменение видимости TooltipElement */
const changeVisibilityTooltipElement = (value) => {
  tooltipElementVisibleState.value = value;
};

const onCreate = (value: CreateNamespaceResultModel) => {
  emit('onCreate', value);
  visible.value = false;
};

defineExpose({
  open,
});
</script>

<template>
  <slot :open="open" />
  <TirPmDrawer v-model:visible="visible" size="51.875rem" :position="TirPmDrawerPositionEnum.Right">
    <template #content="{ close }">
      <div class="create-namespace-drawer">
        <div class="create-namespace-drawer__header">
          <div class="create-namespace-drawer__title-block">
            <h2 class="create-namespace-drawer__title">Новая рабочая область</h2>
          </div>

          <TirPmButton
            :variant="TirPmButtonVariantEnum.LinkState"
            :size="TirPmButtonSizeEnum.Regular"
            @click="close"
          >
            <template #leftSlot>
              <CrossLinedIcon />
            </template>
          </TirPmButton>
        </div>
        <div class="create-namespace-drawer__main">
          <CreateNamespaceForm
            :project-id="projectId"
            @on-create="onCreate"
            @on-cancel="close"
            @tooltipElementVisibleState="changeVisibilityTooltipElement"
          />
        </div>
      </div>
    </template>
  </TirPmDrawer>
</template>

<style lang="scss" scoped>
.create-namespace-drawer {
  height: 100%;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.75rem 1.75rem 0 2.5rem;
  }
  &__tooltip {
    width: 16.938rem;
  }
  &__title-block {
    display: flex;
    align-items: center;
  }
  &__title {
    font-size: 1.625rem;
    font-weight: 500;
    line-height: 2rem;
    color: var(--text-primary, #272d37);
    margin: 0;
  }
  &__status-budge {
    margin-left: 0.625rem;
  }
  &__close-button {
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;

    svg {
      width: inherit;
      height: inherit;
    }
  }
  &__main {
    padding: 2.25rem 2.5rem;
    height: calc(100% - 4.1563rem);
  }
}
</style>
